import React from 'react';
import Loader from '../../../../Loader';
import cbtManagement from '../../../../../apis/cbtManagement';
import { CONFIG } from '../../../../../config';
import ProfilOverviewSearch from '../../../../../entity/ProfilOverviewSearch';
import __ from 'lodash';
import {Link} from 'react-router-dom';
class ProfilCbtOverview extends React.Component{
    state = {
        overview: [],
        isLoading: false
    }

    componentDidMount(){
        this.fetchOverview();
    }

    fetchOverview = async() => {
        if(this.props.isLoadingOverview){
            this.props.isLoadingOverview(true);
        }
        console.log("sekolah :::");
        console.log(this.props.idSekolah);
        this.setState({isLoading: true});
        const response = await cbtManagement.post(CONFIG.CBT_MANAGEMENT_PROFIL_OVERVIEW, {
            ...ProfilOverviewSearch, 
            ["idSekolah"]: this.props.idSekolah,
            ["idProfilCbt"]: this.props.idProfil,
            ["idKelasParalel"]: this.props.idKelasParalel,
            ["kodeTahunAjaran"]: this.props.kodeTahunAjaran
        }).catch(function(error){

        });
        if(response){
            if(response.data != null){
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({overview: response.data.data});
                    if(this.props.callbackFromParent){
                        this.props.callbackFromParent(response.data.data)
                    }
                }
            }
        }
        this.setState({isLoading:false});
        if(this.props.isLoadingOverview){
            this.props.isLoadingOverview(false);
        }
    }

    renderOverview = () =>{
        if(this.state.isLoading){
            return(
                <Loader />
            )
        }else{
            if(!__.isEmpty(this.state.overview)){
                return this.state.overview.map((sub) => {
                    let persenPeserta = 0;
                    console.log("PERSEN PESERTA ::: " + persenPeserta);
                    if(parseInt(this.props.totalPeserta) === 0){
                        persenPeserta = 0;
                        console.log("kosong");
                    }else{
                        console.log("tidak kosong");
                        persenPeserta = parseFloat((sub.jumlahSiswa / parseInt(this.props.totalPeserta)) * 100).toFixed(2);
                    }
                    console.log("PERSEN PESERTA ::: " + persenPeserta);
                    return (
                        <div>
                            {sub.namaMataPelajaran}
                            <div className="progress">
                                <div className="progress-bar" role="progressbar" style={{width: sub.average + "%"}} aria-valuenow={sub.average} aria-valuemin="0" aria-valuemax="100">{sub.average}%</div>
                            </div>
                            <div className="progress">
                                <div className="progress-bar bg-success" role="progressbar" style={{width: persenPeserta+ "%"}} aria-valuenow={persenPeserta} aria-valuemin="0" aria-valuemax="100">{persenPeserta}%</div>
                            </div>
                            <br></br>
                        </div>  
                    )
                })
            }
        }
    }

    renderButton(showButton){
        if(showButton){
            return(
                <div className="float-right">
                <button className="btn btn-primary">Ranking</button> &nbsp;
                <Link to={'/dashboard/report/cbt/detail?idProfil=' + this.props.idProfil} className="btn btn-primary">Detail</Link> &nbsp;
                </div>
            )
        }
    }

    render(){
        return(
            <div>
                {this.renderOverview()}
                <br/>
                {this.renderButton(this.props.showButton)}
            </div>
        )
    }
}

export default ProfilCbtOverview;